import CronSerializer from '@linc-technologies/linced-common/serializers/cron/base';

export default class Task extends CronSerializer {}
